import axios from "axios";
import { propHasValue } from "../components/DynamicFormNew/helper";
import { deepFind } from "./deepFind";
import { getToken } from 'datastake-daf/src/helpers/Token';
import i18next from "i18next";
import { getAppHeader, getMainApiUrl } from "../services/BaseService";
import { getStatusObject, renderAmpTag } from "../components/Forms/amp/columns";
import ProgressBar from "../screens/ViewTIF/components/progressBar";
import { renderEventStatusTag } from "../screens/Modules/tazama/screens/events/columns";

export function showHideForm2(form, data) {
  try {
    if (form.showFormIf) {
      let [field, match, wantedValue] = form.showFormIf.split(/( is | includes | not )/gmi);
      match = match ? match.trim() : null
      const value = deepFind(data, field);
      if (!value) {
        return false;
      }
      return _checkValue(wantedValue, match, value);
    }
  } catch (e) {
    console.error(e);
  }
  return true;
}

export const checkFormCondition = (condition, repeatValues, formsValue) => {
  let [field, match, wantedValue] = condition.split(/( is | includes | not | notEmpty | notOnly )/gmi);
  const isRepeatable = field.split('./').length > 1;
  const isNotEmpty = match === 'notEmpty';
  const formValue = isRepeatable ? repeatValues : formsValue;
  field = isRepeatable ? field.split('./')[1] : field;
  const value = deepFind(formValue, field);
  const isShown = _checkValue(
    isNotEmpty ? field : wantedValue,
    match,
    isNotEmpty ? formValue : value
  );
  return isShown;
}

export function showHideForm(form, formsValue) {
  if (form.showFormIf) {
    const isOrCond = form.showFormIf.indexOf('OR') >= 0;
    const allParts = form.showFormIf.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
    const parts = allParts.map(condition => {
      let [field, match, wantedValue] = condition.split(/( is | includes | not | notEmpty | notOnly )/gmi);
      match = match ? match.trim() : null;
      const isNotEmpty = match === 'notEmpty';
      if (match && field.split('.').length > 1) {
        if ((!formsValue)) {
          return false;
        } else {
          const value = deepFind(formsValue, field);
          const isShown = _checkValue(
            isNotEmpty ? field : wantedValue,
            match,
            isNotEmpty ? formsValue : value
          );
          return isShown;
        }
      } else {
        const value = deepFind(formsValue, field);
        const isShown = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formsValue : value
        );
        return isShown;
      }
    });
    const isShown = parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
    return isShown;
  }
  return true;
}

export function _checkValue(wantedValue, match, fieldValue) {
  match = match ? match.trim() : null
  if (!match) {
    return propHasValue(fieldValue) || (Array.isArray(fieldValue) && fieldValue.length > 0) ? true : false
  } else {
    const values = wantedValue.split(',');
    if (match === 'is') {
      if (values.length === 1) {
        return Array.isArray(fieldValue) ? (fieldValue.includes(values[0])) : String(fieldValue) === values[0];
      } else {
        return false
      }
    }
    if (match === 'includes') {
      if (values.length) {
        return Array.isArray(fieldValue) ? (values.filter(v => fieldValue.includes(v)).length > 0) : values.includes(String(fieldValue));
      } else {
        return false;
      }
    }
    if (match === 'not') {
      if (values.length && propHasValue(fieldValue)) {
        return Array.isArray(fieldValue) ? (values.filter(v => fieldValue.includes(v)).length === 0) : !values.includes(String(fieldValue));
      } else {
        return false;
      }
    }
    if (match === 'notOnly') {
      if (values.length) {
        return Array.isArray(fieldValue) ? (values.filter(v => fieldValue.includes(v)).length === 0) : !values.includes(String(fieldValue));
      } else {
        return false;
      }
    }
    if (match === 'notEmpty') {
      return fieldValue && Object.keys(fieldValue).includes(wantedValue) && (!Array.isArray(fieldValue[wantedValue]) || (Array.isArray(fieldValue[wantedValue]) && fieldValue[wantedValue].length > 0));
    }
  }
  return false;
}

export async function getFormOptions(form, exclude = [], formData) {
  const endpoint = `${getMainApiUrl()}/query/options`;
  const calls = await Promise.all(Object.keys(form)
    .filter(key => !exclude.includes(key))
    .reduce((cll, sectionKey) => {
      Object.keys(form[sectionKey])
        .filter(key => !exclude.includes(key))
        .forEach(fKey => {
          if (!form[sectionKey][fKey].inputs) {
            if (form[sectionKey][fKey].inputType === 'ajaxSelect') {
              cll.push({
                call: form[sectionKey][fKey].call,
                repeatable: false,
                value: formData[fKey] ? [formData[fKey]].filter(v => v) : [],
              });
            }
          } else {
            Object.keys(form[sectionKey][fKey].inputs).forEach(iKey => {
              if (form[sectionKey][fKey].inputs[iKey].inputType === 'ajaxSelect') {
                if (form[sectionKey][fKey].repeatable) {
                  cll.push({
                    call: form[sectionKey][fKey].inputs[iKey].call,
                    repeatable: true,
                    value: formData[fKey] ? (formData[fKey]).map(v => v[iKey]).filter(v => v) : [],
                  });
                } else {
                  cll.push({
                    call: form[sectionKey][fKey].inputs[iKey].call,
                    repeatable: false,
                    value: formData[fKey] && formData[fKey][iKey] ? [formData[fKey][iKey]].filter(v => v) : [],
                  });
                }
              }
            });
          }
        });
      return cll;
    }, [])
    .reduce((config, c) => {
      const [entity, method, mapper] = c.call.split('::');
      const m = method.split(/\(/)[0];
      const key = `${entity}-${m}`;
      const ind = config.find(c => c.key === key);
      if (ind >= 0) {
        config[ind] = {
          ...config[ind],
          value: [
            ...config[ind].value,
            ...c.value.filter(v => v),
          ]
        }
      } else {
        config.push({
          key,
          entity,
          method: m,
          mapper,
          value: c.value
        })
      }
      return config;
    }, [])
    .map(async call => {
      const res = await axios.post(endpoint, {
        entity: call.entity,
        method: call.method,
        mapper: JSON.parse(call.mapper),
        filters: {
          ids: call.value.filter(v => v)
        },
      }, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          ...getAppHeader(),
        },
      });
      if (res.data) {
        return res.data;
      }
      return [];
    }));
  return [].concat(...calls);
}

export function filterOptions(options, filters, formsValue = {}, repeatValues = {}, filterCond = null) {
  const isOrCond = filterCond !== 'and';
  const objFilter = {};
  filters.forEach(f => {
    const [name, p] = f.split('|');
    const [path, delimeter] = p.split(/( as )/gmi);
    let value;
    let isRepeatable = false;
    if (delimeter && delimeter.trim() === 'as') {
      value = path;
    } else {
      const pathInsideRepeatValues = path.split('./');
      isRepeatable = pathInsideRepeatValues.length > 1;
      value = deepFind(isRepeatable ? repeatValues : formsValue, pathInsideRepeatValues[pathInsideRepeatValues.length - 1]);
    }
    objFilter[name] = {
      value,
      isRepeatable
    };
  });
  options = options.filter(o => {
    if (!o.filters) {
      return true;
    } else {
      const opFilters = o.filters.filter(fi => objFilter[fi.name]);
      if (opFilters.length === 0) {
        return true;
      }
      const parts = opFilters.map(fi => {
        const filter = objFilter[fi.name];
        const value = Array.isArray(filter.value) ? filter.value : [filter.value];
        return _checkValue(
          value.join(','),
          fi.condition,
          fi.value
        );
      });
      return parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
      // if (!filter) {
      //   return true;
      // } else {
      //   if (Array.isArray(value)) {
      //     switch (filter.condition) {
      //       case 'includes':
      //         return filter.value && Array.isArray(filter.value) && filter.value.filter(v => value.includes(v)).length > 0;
      //       case 'and':
      //         return filter.value && Array.isArray(filter.value) && filter.value.filter(v => v.filter(vv => value.includes(vv).length > 0)).length > 0;
      //       default:
      //         return value.includes(filter.value);
      //     }
      //   } else {
      //     switch (filter.condition) {
      //       case 'includes':
      //         return filter.value && Array.isArray(filter.value) && filter.value.includes(value);
      //       case 'and':
      //         return filter.value && Array.isArray(filter.value) && filter.value.filter(v => v.includes(value)).length > 0;
      //       default:
      //         return filter.value === value;
      //     }
      //   }
      // }
    }
  })
  return options;
}

export const getImageUploadEditValue = (value) => {
  return (
    Array.isArray(value) ? value :
      (
        value &&
          typeof value === 'object' &&
          value.fileList &&
          Array.isArray(value.fileList) ?
          value.fileList.map(f => f.response).filter(f => f) : []
      )
  ) || [];
}

export const getImageUploadViewValue = (value) => {
  return Array.isArray(value) ? value : (
    value && value.fileList && Array.isArray(value.fileList) ?
      value.fileList.map(v => v.response ? v.response : v) : []);
}

export const formPaths = {
  edit: (mod) => `/app/${mod}/edit/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?`,
  view: (mod) => `/app/${mod}/view/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?`,
  viewDD: (mod) => `/app/${mod}/viewdd/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?`,
  editDD: (mod) => `/app/${mod}/editdd/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?`,
}

export const CREATE_DRAWER_WIDTH = 480;
export const CREATE_DRAWER_WIDTH_LARGE = 980;

export const MAX_COMMENTS_LENGTH = 400;

export const MAX_TEXT_AREA_LENGTH = 400;

export const MAX_TEXT_INPUT_LENGTH = 60;

export const getMetaPlaceholer = (inputMeta) =>
  inputMeta.notApplicable
    ? i18next.t('Not applicable')
    : inputMeta.notAvailable
      ? i18next.t('No available information')
      : undefined

export const namespaceAllPath = {
  stakeholder: 'stakeholders',
  amp: 'amp',
  programs: 'programs',
  'application-form': 'application-form',
  'mine-profile': 'mine-profile',
  'ownership-kyc': 'mine-profile',
  'esg-assessment': 'mine-profile',
  scp: 'scp',
  'mine-operators': 'mine-operators',
  location: 'locations',
  scl: 'scl',
  village: 'village',
  event: 'events',
  incidents: 'incidents',
  initiatives: 'initiatives',
  'corrective-actions': 'corrective-actions',
  testimonials: 'testimonials',
  lir: 'lir',
  project: 'projects',
  kyc: '',
  sp: '',
  im: '',
  sci: '',
  bpe: '',
  gm: '',
}

export const dataKey = {
  stakeholder: 'stakeholderData',
  amp: 'ampData',
  programs: 'programsData',
  'application-form': 'applicationFormData',
  'mine-profile': 'mineProfileData',
  'ownership-kyc': 'ownershipKycData',
  'esg-assessment': 'esgAssessmentData',
  scp: 'stakeholderData',
  'mine-operators': 'stakeholderData',
  kyc: 'stakeholderData',
  location: 'sclData',
  scl: 'sclData',
  village: 'sclData',
  event: 'eventData',
  incidents: 'eventData',
  initiatives: 'linkedSubjectsData',
  victims: 'linkedSubjectsData',
  pictures: 'linkedSubjectsData',
  'corrective-actions': 'eventData',
  testimonials: 'eventData',
  documents: 'documentData',
  lir: 'lirData',
  project: 'projectData',
  sp: 'spData',
  im: 'imData',
  sci: 'sciData',
  bpe: 'bpeData',
  gm: 'gmData',
};

export const viewKey = {
  stakeholder: 'stakeholderView',
  amp: 'ampView',
  programs: 'programsView',
  'application-form': 'applicationFormView',
  'mine-profile': 'mineProfileView',
  'ownership-kyc': 'ownershipKycView',
  'esg-assessment': 'esgAssessmentView',
  scp: 'stakeholderView',
  'mine-operators': 'stakeholderView',
  location: 'sclView',
  scl: 'sclView',
  village: 'sclView',
  event: 'eventView',
  incidents: 'eventView',
  initiatives: 'linkedSubjectsView',
  pictures: 'linkedSubjectsView',
  victims: 'linkedSubjectsView',
  'corrective-actions': 'eventView',
  testimonials: 'eventView',
  documents: 'documentView',
  lir: 'lirView',
  project: 'projectView',
  kyc: 'stakeholderView',
  sp: 'spView',
  im: 'imView',
  sci: 'sciView',
  bpe: 'bpeView',
  gm: 'gmView',
};

export const renderPageTittle = ({
  namespace,
  viewConfig,
  data,
  language,
  mod,
  view = 'view',
  t = (s) => s,
}) => {
  const returnDefault = () => {
    if (viewConfig.title) {
      const title = viewConfig.title[language];
      return title;
    }

    return '';
  };

  switch (namespace) {
    case 'amp':
      return (
        <div className="title flex">
          <h2 className="mb-0 mr-1 limited">
            {(viewConfig?.title || {})[language] || ''}
          </h2>
          {data.applicationFormStatus ? (
            <div className="ml-3">
              {renderAmpTag({ status: getStatusObject(data.applicationFormStatus), t })}
            </div>
          ) : (
            <div className='ml-3 flex flex-column justify-content-center'>
              <ProgressBar percentage={data.ampCompletionPercentage} />
            </div>
          )}
        </div>
      );
    case 'application-form':
      return (
        <div className="title flex">
          <h2 className="mb-0 mr-1 limited">
            {t('Application Form')}
          </h2>
          {(data.applicationFormStatus && data.applicationFormStatus !== "registered") ? (
            <div className="ml-3">
              {renderAmpTag({ status: getStatusObject(data.applicationFormStatus), t })}
            </div>
          ) : (
            <div className='ml-3 flex flex-column justify-content-center'>
              <ProgressBar percentage={data.ampCompletionPercentage} />
            </div>
          )}
        </div>
      );
    case 'ownership-kyc':
      return (
        <div className="title flex">
          <h2 className="mb-0 mr-1 limited">
            {(viewConfig?.title || {})[language] || ''}
          </h2>
          {(data.kycStatus && data.kycStatus !== "registered") ? (
            <div className="ml-3">
              {renderAmpTag({ status: getStatusObject(data.kycStatus), t })}
            </div>
          ) : (
            <div className='ml-3 flex flex-column justify-content-center'>
              <ProgressBar percentage={data.kycCompletionPercentage} />
            </div>
          )}
        </div>
      );
    case 'mine-profile':
      return (
        <div className="title flex">
          <h2 className="mb-0 mr-1 limited">
            {(viewConfig?.title || {})[language] || ''}
          </h2>
          {(data.mineProfileStatus && data.mineProfileStatus !== "registered") ? (
            <div className="ml-3">
              {renderAmpTag({ status: getStatusObject(data.mineProfileStatus), t })}
            </div>
          ) : (
            <div className='ml-3 flex flex-column justify-content-center'>
              <ProgressBar percentage={data.mineProfileCompletionPercentage} />
            </div>
          )}
        </div>
      );
    case 'incidents':
    case 'corrective-actions':
    case 'testimonials':
      if (mod === 'tazama' && view === 'view') {
        return (
          <div className="title flex">
            <h2 className="mb-0 mr-1 limited">
              {(viewConfig?.title || {})[language] || ''}
            </h2>
            {data.published ? (
              <div className="ml-3">
                {renderEventStatusTag({ value: 'submitted', t })}
              </div>
            ) : (
              <div className='ml-3 flex flex-column justify-content-center'>
                <ProgressBar percentage={`${data.percentageCompletion}%`} />
              </div>
            )}
          </div>
        );
      }
      break;
    default:
  }

  return returnDefault();
};

export const supportedNamespaces = {
  cadd: [
    'stakeholder', 'scp', 'location', 'scl', 'village', 'project', 'event', 'incidents', 'corrective-actions', 'document', 'lir', 'kyc', 'sp', 'im', 'sci', 'bpe', 'gm',
  ],
  pme: [
    'stakeholder', 'scp', 'location', 'scl', 'village', 'project', 'event', 'document', 'lir', 'incidents', 'corrective-actions', 'kyc',
  ],
  tif: [
    'mine-operators', 'stakeholder', 'scp', 'location', 'scl', 'village', 'project', 'event', 'incidents', 'corrective-actions', 'document', 'lir', 'kyc', 'sp', 'im', 'sci', 'bpe', 'gm', 'amp', 'application-form', 'mine-profile', 'ownership-kyc', 'programs', 'esg-assessment'
  ],
  tazama: [
    'event', 'incidents', 'corrective-actions', 'initiatives', 'stakeholder', 'location', 'victims', 'pictures', 'documents', 'testimonials'
  ]
}

export const sortForm = ({ form }) => {
  const _form = Object.keys(form).reduce((all, key) => {
    const _this = Object.keys(form[key])
      .sort((a, b) => form[key][a].position - form[key][b].position)
      .reduce((all, k) => {
        if (k === 'scope') {
          return all;
        }

        all[k] = form[key][k];
        return all;
      }, {});

    all[key] = _this;
    return all;
  }, {});

  return _form;
}

export const tooltipInputs = [
  'text', 'phoneNumber', 'textarea', 'link', 'percentage', 'number',
  'select', 'ajaxSelect', 'switch', 'multiselect', 'radioGroup',
  'date', 'year', ''
];
